query SendMeEmailDigest {
    sendMeEmailDigest
}
